/** 傾斜を生じた階の上の階数 */
export const ABOVE_SLOPE_FLOOR_LEVEL = {
  /** 1階以下 */
  ONE_OR_LESS: '1',
  /** 2階以上 */
  TWO_OR_MORE: '2'
} as const

export type AboveSlopeFloorLevel =
  (typeof ABOVE_SLOPE_FLOOR_LEVEL)[keyof typeof ABOVE_SLOPE_FLOOR_LEVEL]
